module.exports = __webpack_public_path__ + "static/work-3-d88ac1e83e642ca2ecb100977b5dfa8e.png";